export default __webpack_public_path__ + "static/media/coolblue.baba6f3a.svg";